'use client';


import { loadSounds, isLoaded, playLoop, playSfx as enginePlaySfx } from '../../../lib/audioEngine';

const MUTE_KEY = 'rushmid:muted';
// WHY: localStorage под guard — часть Android WebView бросает SecurityError при блокировке site data; на module eval это
// чёрный экран app
let muted = false;
try { muted = typeof window !== 'undefined' && window.localStorage.getItem(MUTE_KEY) === '1'; } catch { }
const muteListeners = new Set<() => void>();

export function isMuted(): boolean {
  return muted;
}
export function subscribeMuted(cb: () => void): () => void {
  muteListeners.add(cb);
  return () => muteListeners.delete(cb);
}
export function setMuted(next: boolean): void {
  if (muted === next) return;
  muted = next;
  try { window.localStorage.setItem(MUTE_KEY, next ? '1' : '0'); } catch { }
  if (muted) stopMusic();
  muteListeners.forEach((cb) => cb());
}

export function playSfx(name: string, volume = 1): void {
  if (muted) return;
  enginePlaySfx(name, volume);
}

export const SFX = [
  'timer_beep', 'buttonclickrelease', 'match_found', 'match_win', 'match_lose', 'ct_win', 't_win', 'battle_start',
  'shot_ak', 'shot_m4', 'shot_lmg', 'shot_awp', 'grenade_throw', 'grenade_explode', 'medkit',
  'armor_hit', 'headshot', 'death', 'click', 'knife_deploy', 'knife_stab',
  'smoke_bloom', 'party_join', 'flash_explode', 'grenade_land', 'flash_blind', 'casing_drop',
  'ricochet_1', 'ricochet_2', 'ricochet_3', 'ricochet_4', 'ricochet_5', 'ricochet_6',
  'footstep', 'serdcebienie-normalnoe_zx0xpSKX',
] as const;

export const RICOCHET_SFX = ['ricochet_1', 'ricochet_2', 'ricochet_3', 'ricochet_4', 'ricochet_5', 'ricochet_6'] as const;

let preloadPromise: Promise<void> | null = null;

export const SFX_COUNT = SFX.length;

export function isSfxReady(): boolean {
  return SFX.every((n) => isLoaded(n));
}

export function preloadSfx(onUnit?: () => void): Promise<void> {
  if (!preloadPromise) preloadPromise = loadSounds(SFX, onUnit);
  return preloadPromise;
}

const MUSIC = 'menu_theme';
let stopLoop: (() => void) | null = null;
let musicGen = 0;

export function preloadMusic(): Promise<void> {
  return loadSounds([MUSIC]).catch(() => undefined);
}

export async function startMusic(volume = 0.35): Promise<void> {
  if (stopLoop || muted) return;
  const gen = ++musicGen;
  const stop = await playLoop(MUSIC, volume);
  if (musicGen !== gen) { stop(); return; }
  stopLoop = stop;
}

export function stopMusic(): void {
  musicGen++;
  if (stopLoop) { stopLoop(); stopLoop = null; }
}

let musicClaims = 0;
let musicReleaseTimer: ReturnType<typeof setTimeout> | null = null;

export function claimMusic(): () => void {
  musicClaims++;
  if (musicReleaseTimer) { clearTimeout(musicReleaseTimer); musicReleaseTimer = null; }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    musicClaims--;
    if (musicClaims <= 0) {
      musicReleaseTimer = setTimeout(() => {
        if (musicClaims <= 0) stopMusic();
      }, 200);
    }
  };
}

const HEARTBEAT = 'serdcebienie-normalnoe_zx0xpSKX';
let stopHeartbeatLoop: (() => void) | null = null;
let heartbeatGen = 0;

export async function startHeartbeat(volume = 0.6): Promise<void> {
  if (stopHeartbeatLoop || muted) return;
  const gen = ++heartbeatGen;
  const stop = await playLoop(HEARTBEAT, volume);
  if (heartbeatGen !== gen) { stop(); return; }
  stopHeartbeatLoop = stop;
}

export function stopHeartbeat(): void {
  heartbeatGen++;
  if (stopHeartbeatLoop) { stopHeartbeatLoop(); stopHeartbeatLoop = null; }
}
